import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getElections } from 'pollworker/src/fetchers';
import type { AppState } from 'pollworker/src/state/store';

export type PollworkerElection = {
  Id: string;
  ElectionName: string;
};

export const ELECTION_ACTION_TYPES = {
  SET_ELECTION_ID: 'SET_ELECTION_ID',
};
export const setElectionId = createAction<string>(ELECTION_ACTION_TYPES.SET_ELECTION_ID);

export const loadElections = createAsyncThunk('election/loadElections', () => getElections(), {
  condition: (_, { getState }) => {
    const election = (getState() as AppState).election;
    return election.elections == null && !election.loading;
  },
});
